import { useCallback } from "react";

export const IVA_RATE = 0.16;
export const IVA_PERCENTAGE = 16;

// Normaliza null/undefined/"" o strings inválidos a 0 para evitar NaN.
export const toNumber = (value) => parseFloat(value) || 0;

// Redondea a 2 decimales evitando los artefactos de punto flotante.
export const round2 = (value) =>
  Math.round((toNumber(value) + Number.EPSILON) * 100) / 100;

/**
 * Lógica compartida de IVA para los formularios de pago.
 *
 * @param {Function} watch       watch del react-hook-form de la vista (watch2/watch3).
 * @param {Function} setValue    setValue del react-hook-form de la vista.
 * @param {Function} [afterChange] Callback opcional que se ejecuta tras recalcular el
 *                                IVA (p. ej. recalcular paymentDifference en Services).
 */
export default function useIvaCalculation({ watch, setValue, afterChange } = {}) {
  const handleAddIva = useCallback(
    (event, valuesToSum = [], passCheck = false) => {
      // Fuente de verdad: el checkbox addIva, no el valor derivado ivaAmount.
      const isChecked = passCheck
        ? Boolean(watch("addIva"))
        : Boolean(event?.target?.checked);

      const base = valuesToSum.reduce(
        (sum, item) => sum + toNumber(item?.valueToSum),
        0
      );

      if (isChecked) {
        setValue("ivaPercentage", IVA_PERCENTAGE);
        setValue("ivaAmount", round2(base * IVA_RATE));
      } else {
        setValue("ivaPercentage", 0);
        setValue("ivaAmount", 0);
      }

      afterChange?.();
    },
    [watch, setValue, afterChange]
  );

  return { handleAddIva };
}
